import { readCookie } from '@zapier/cookies';
import { SSO_HINT_COOKIE_NAME } from '../constants';

export function getSsoHintFromCookie() {
  if (typeof document === 'undefined') {
    return undefined;
  }
  const ssoHint = readCookie(SSO_HINT_COOKIE_NAME);
  // if the cookie is null or undefined, return undefined
  if (!ssoHint || ssoHint === 'null' || ssoHint === 'undefined') {
    return undefined;
  }
  return ssoHint;
}
